import type { RankBoard, RankEntry, SetsBoard } from "./types";
import { fmt, fmt1 } from "./format";

export type BoardKey = "avg_check" | "revenue_per_shift" | "sets";

/**
 * Высоты ступенек лесенки по убыванию (решение владельца 28.10.2026): первое место самое высокое,
 * каждое следующее ниже. Пиксели, для колонок одной ширины.
 */
export function ladderHeights(total: number, top = 88, step = 14, min = 28): number[] {
  return Array.from({ length: total }, (_, i) => Math.max(min, top - i * step));
}

export const MEDALS: Record<number, string> = { 1: "🥇", 2: "🥈", 3: "🥉" };

/** Подпись места: медаль на первых трёх, дальше номер. */
export function placeMark(place: number): string {
  return MEDALS[place] ?? String(place);
}

/** Значение доски в тексте: грн без копеек у денег, один знак у баллов. */
export function formatValue(key: BoardKey, value: number): string {
  return key === "sets" ? fmt1(value) : fmt(value);
}

/** Фамилия и инициал: «Гопкало Оксана» → «Гопкало О.» (вид владельца). */
export function shortName(full: string | null | undefined, fallback: string): string {
  if (!full) return fallback;
  const parts = full.trim().split(/\s+/);
  if (parts.length < 2) return full;
  return `${parts[0]} ${parts[1]![0]}.`;
}

export type BoardState =
  | { kind: "no_data" }        // записей нет и своих цифр нет
  | { kind: "too_few" }        // меньше двух участниц
  | { kind: "ok" };

/** Что показывать вместо лесенки, если участниц мало. */
export function boardState(b: RankBoard | SetsBoard): BoardState {
  if (b.total >= 2) return { kind: "ok" };
  const hasOwn = "my_bra_checks" in b && b.my_bra_checks != null;
  if (b.total === 0 && !hasOwn) return { kind: "no_data" };
  return { kind: "too_few" };
}

/** Своя запись на доске (сотрудница), если участвует. */
export function myEntry(b: RankBoard): RankEntry | null {
  return b.entries.find(e => e.me) ?? null;
}
